import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material/styles";
import { MedphotoProvider } from "medphoto.context";
import React from "react";
import ReactDOM from "react-dom/client";

import "semantic-ui-css/semantic.min.css";
import "./index.css";
import { AuthenticationWrapper } from "./medtankengroup-authentication/components";
import reportWebVitals from "./reportWebVitals";
import { AppRoutes } from "./routes";

const theme = createTheme({
  palette: {
    primary: {
      main: "#222d59",
    },
    secondary: {
      main: "#d91f84",
    },
    success: {
      main: "#1aa57e",
      contrastText: "#fff",
    },
  },
  typography: {
    allVariants: {
      fontFamily: "Hind Madurai, Helvetica Neue, Arial, Helvetica, sans-serif",
    },
    body1: {
      color: "#000",
    },
    h1: {
      fontFamily: '"Days One", sans-serif',
    },
    h2: {
      fontFamily: '"Days One", sans-serif',
    },
    h3: {
      fontFamily: '"Days One", sans-serif',
    },
    h4: {
      fontFamily: '"Days One", sans-serif',
    },
    h5: {
      fontFamily: '"Days One", sans-serif',
      color: "var(--clr-medtanken-primary)",
    },
    h6: {
      fontWeight: "bold",
      color: "var(--clr-medtanken-primary)",
      fontSize: "medium",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <AuthenticationWrapper>
        <MedphotoProvider>
          <AppRoutes />
        </MedphotoProvider>
      </AuthenticationWrapper>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
